import { Component, OnInit, Input } from '@angular/core';


@Component({
  selector: 'iho-white-box-border-bottom',
  templateUrl: './white-box-border-bottom.component.html',
  styleUrls: ['./white-box-border-bottom.component.scss']
})
export class WhiteBoxBorderBottomComponent implements OnInit {
  @Input() boxData: any[] = [];
  // ---
  @Input() colNumber: number = 0;
  // ---
  constructor() { }

  ngOnInit(): void {
  }

}
